// Import Buffer polyfill first to ensure it's available globally
import './utils/base64Polyfill';

// Mock problematic emotion/cache
// This needs to happen before any other imports that might use emotion
if (typeof window !== 'undefined') {
  // Only apply in browser environment
  try {
    // Create a simple mock cache to prevent errors
    const mockCache = {
      key: 'css',
      sheet: { 
        insert: () => {}, 
        flush: () => {}, 
        tags: [] 
      },
      inserted: {},
      registered: {},
      nonce: undefined
    };
    
    // Patch window with mock implementation
    window.emotionMockCache = mockCache;
  } catch (err) {
    console.error('Failed to initialize emotion mock:', err);
  }
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ApolloClient, ApolloProvider, HttpLink, InMemoryCache} from '@apollo/client';
import {BrowserRouter} from "react-router-dom";
import './i18n';
import introspectionResults from "service/introspectionQueryResults";
import readConfig from './utils/readClientConfiguration';
import appConfiguration from './config/default.json';

const possibleTypes = {};
introspectionResults.__schema.types.forEach(supertype => {
    if (supertype.possibleTypes) {
        possibleTypes[supertype.name] = supertype.possibleTypes.map(subtype => subtype.name);
    }
});

// GraphQL endpoint będzie na tym samym hoście, ale pod ścieżką /graphql
const graphqlUrl = '/graphql';

// Konfiguracja Apollo Client
const client = new ApolloClient({
    link: new HttpLink({
        uri: graphqlUrl,
        credentials: 'include',
    }),
    cache: new InMemoryCache({ possibleTypes }),
    defaultOptions: { watchQuery: { fetchPolicy: 'network-only' } },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ApolloProvider client={client}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </ApolloProvider>
    </React.StrictMode>
);

reportWebVitals(console.log);